import Vue from 'vue'
import VueI18n from 'vue-i18n'
import VueResource from 'vue-resource'

import messages from './i18n'
import WebSocketClient from '@/components/basic-native-rws'

Vue.config.productionTip = false

Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'fr', // set locale
  fallbackLocale: 'en',
  messages // set locale messages
})

function load (settings, store) {
  Vue.prototype.$settings = settings

  Vue.prototype.$socket = new WebSocketClient()

  Vue.use(VueResource)
  Vue.http.options.root = `${settings.host}/api/v1`

  Vue.http.get(settings.url)
    .then(response => response.json())
    .then((params) => {
      import(/* webpackChunkName: 'main' */ `@/custom/${process.env.VUE_APP_LABEL}.vue`)
        .then((module) => {
          store.commit('initial', params)
          store.commit('updateCaller', settings.caller)

          new Vue({
            i18n,
            store,
            render: h => h(module.default)
          }).$mount(settings.elt)
          store.dispatch({
            type: 'handleAutoOpen'
          })
        })
    })
}

function init () {
  import(/* webpackChunkName: 'settings' */ '@/settings').then((module) => {
    const settings = module.default()
    let store
    // console.log('STORE?', `${process.env.VUE_APP_STORE}`)
    if (process.env.VUE_APP_STORE === undefined) {
      // console.log('STD STORE')
      import(/* webpackChunkName: 'store' */ '@/store').then((module) => {
        store = module.default
        load(settings, store)
      })
    } else {
      // console.log('CUSTOM STORE')
      import(/* webpackChunkName: 'store' */ `@/custom/${process.env.VUE_APP_STORE}`).then((module) => {
        store = module.default
        load(settings, store)
      })
    }
  })
}

init()
